export function modifyRequest(Vue){
  Vue.http.interceptors.push((request,next)=>{
    next((response)=>{
      if(response && response.body.code ==200){
        // 获取当前语言
        let lang = localStorage.getItem('languageSet')||'zh'
        if(lang && lang == 'en'){
          response.body.msg = 'operation success'
        }
      }
      return response
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/config.js